import { InputDate } from '@te-whatu-ora/anatomic'

export type InputDateValue = NonNullable<
  React.ComponentProps<typeof InputDate>['value']
>

export function toInputDateValue(date: string | null): InputDateValue {
  if (date === null) return {}

  const [year, month, day] = date.split('-')

  return {
    day,
    month,
    year
  }
}

// Serialises the three date fields into a valid FHIR `date` value.
// FHIR dates are prefixes: YYYY, YYYY-MM, or YYYY-MM-DD (a month requires a
// year and a day requires a month). Each present component is zero-padded
// (year to 4 digits, month/day to 2) so single-digit entry like 2000-1-1
// becomes valid FHIR (2000-01-01) instead of being rejected by the server.
// Parts that can't be expressed as a prefix - a day with no month, or anything
// with no year - are dropped.
export function toDateString({
  day,
  month,
  year
}: InputDateValue): string | null {
  if (!day && !month && !year) return null
  if (!year) return null

  let result = year.padStart(4, '0')

  if (month) {
    result += `-${month.padStart(2, '0')}`

    if (day) {
      result += `-${day.padStart(2, '0')}`
    }
  }

  return result
}

// YYYY-MM-DD
export function toFullDateString({
  day,
  month,
  year
}: InputDateValue): string | null {
  if (!day && !month && !year) return null
  return `${year ?? ''}-${month ?? ''}-${day ?? ''}`
}
